import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PlayerProvider } from "@/context/PlayerContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Topics } from "@/components/Topics";
import { Episodes } from "@/components/Episodes";
import { HostBio } from "@/components/HostBio";
import { Newsletter } from "@/components/Newsletter";
import { Footer } from "@/components/Footer";
import { AudioPlayer } from "@/components/AudioPlayer";
import { Music } from "@/components/Music";
import { Resources } from "@/components/Resources";
import { PrayerWall } from "@/components/PrayerWall";
import { Merch } from "@/components/Merch";
import { DiscoveryCall } from "@/components/DiscoveryCall";
import { CountdownBanner } from "@/components/CountdownBanner";
import { Welcome } from "@/components/Welcome";
import { MyBecoming } from "@/components/MyBecoming";
import { FinaleCelebration } from "@/components/FinaleCelebration";
import { FeaturedIn } from "@/components/FeaturedIn";
import AdminPage from "@/pages/AdminPage";
import PressKit from "@/pages/PressKit";

const Home = () => {
    return (
        <PlayerProvider>
            <div className="App relative">
                <CountdownBanner />
                <Nav />
                <main>
                    <Hero />
                    <FeaturedIn />
                    <Welcome />
                    <About />
                    <Topics />
                    <Episodes />
                    <Resources />
                    <Music />
                    <HostBio />
                    <DiscoveryCall />
                    <PrayerWall />
                    <Merch />
                    <Newsletter />
                </main>
                <Footer />
                <AudioPlayer />
                <MyBecoming />
                <FinaleCelebration />
                <Toaster position="top-center" />
            </div>
        </PlayerProvider>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/press-kit" element={<PressKit />} />
                <Route path="/admin" element={<AdminPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
